import React from "react";
import styled from "styled-components";
import { BASIC_YELLOW } from "../../../constants/colors";
import { Campaign } from "../../../ducks/campaign";
import { useAsset } from "../../../hooks/useAsset";
import { Button } from "../../atoms/Button";

type Props = {
  campaign: Campaign | null;
  handleRegularOrderClick: () => void;
  handleEarlyBirdClick: () => void;
};

export const EarlyBirdCampaign: React.FC<Props> = ({
  campaign,
  handleRegularOrderClick,
  handleEarlyBirdClick,
}) => {
  const { baseDir } = useAsset();
  return (
    <StyledContainer>
      {/* Header */}
      <StyledHeaderText>ご希望のご注文を選択してください</StyledHeaderText>

      {/* Regular Order Option */}
      <StyledOptionContainer>
        <StyledOption>
          <StyledOptionContent>
            <StyledImageContainer onClick={handleRegularOrderClick}>
              <StyledImage
                src={`${baseDir}/assets/images/order_regular.svg`}
                alt="Regular order"
              />
            </StyledImageContainer>

            <Button
              btnStyle="primary"
              size="full"
              text="店舗検索へ"
              onClick={handleRegularOrderClick}
              rounded="md"
            />
          </StyledOptionContent>
        </StyledOption>

        {/* Early Bird Campaign Option */}
        <StyledOption>
          <StyledOptionContent>
            <StyledImageContainer onClick={handleEarlyBirdClick}>
              <StyledImage
                src={
                  campaign?.image ||
                  `${baseDir}/assets/images/order_early_bird.svg`
                }
                alt="Early bird campaign"
              />
            </StyledImageContainer>

            <Button
              btnStyle="primary"
              size="full"
              text="店舗検索へ"
              onClick={handleEarlyBirdClick}
              rounded="md"
            />
          </StyledOptionContent>
        </StyledOption>
      </StyledOptionContainer>
    </StyledContainer>
  );
};

const StyledContainer = styled.div`
  display: flex;
  flex-direction: column;
`;

const StyledHeaderText = styled.h1`
  padding: 13px 28px 8px 28px;
  font-size: 20px;
  font-weight: 600;
  font-style: normal;
  line-height: 40px;
  letter-spacing: 0;
  text-align: center;
  margin: 0;
  @media (min-width: 768px) {
    font-size: 24px;
  }
`;

const StyledOptionContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: 13px;
  padding: 0 10px;
  margin-bottom: 27px;
`;

const StyledOption = styled.div`
  min-width: 355px;
  min-height: 260px;
  border-radius: 8px;
  border: 2px solid ${BASIC_YELLOW};
`;

const StyledOptionContent = styled.div`
  padding: 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 20px;
`;

const StyledImageContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  height: 100%;
`;

const StyledImage = styled.img`
  width: 100%;
  height: 100%;
  object-fit: contain;
`;
